<template>
  <div>
    <div class="video-wrapper">
      <video
        ref="elememtVideo"
        id="player"
        class="emav"
        preload="auto"
        autoplay="true"
        playsinline
        webkit-playsinline
        :x5-playsinline="isWeixin"
      ></video>
      <div class="video-img" v-if="!hasAuth">
        <img :src="videoImg" alt />
      </div>
      <div class="mask" v-if="!hasAuth">
        <div v-if="showPurchase">
          <div class="tips">该课程需要购买后才能观看</div>
          <button @click="buyCourse">立即订购</button>
        </div>
        <div v-else class="tips">敬请期待</div>
      </div>
      <div class="video-img" v-if="hasAuth&&isPreview">
        <img :src="previewImg" alt />
      </div>
      <div class="mask preview-mask" v-if="hasAuth&&isPreview">
        <div class="tips">直播未开始</div>
        <div>直播将于{{previewStartTime}}开始</div>
      </div>
      <div class="last-seen" v-show="showLastSeen">
        <span @click="hideLastSeen" class="close">X</span>
        <span>记忆您上次看到{{playTime|formatTime}}</span>
        <span class="jump" @click="jumpToTime">跳转播放</span>
      </div>
    </div>
    <ul class="nav">
      <li
        v-for="(item, index) in nav"
        :class="{ active: index == currentIndex }"
        :key="index"
        @click="
                    changeNav(index, item.view);
                "
        disabled
      >{{ item.label }}</li>
    </ul>
    <div class="content-wrapper" ref="content" :style="contentHeight">
      <keep-alive>
        <component
          v-bind:is="tabView"
          :title="courseTitle"
          :priceInfo="priceInfo"
          :purchase-num="purchaseNum"
          @on-video-click="changeVideo"
          :discussion="discussionArray"
          :video-title="videoTitle"
          :view-num="viewNum"
          :time="publishTime||previewStartTime"
          :is-daily-free="dailyFree"
          :current-play-time="playTime"
          :auth-type="authType"
          :current-item="currentChannel"
          :online-num="onlineNum"
        ></component>
      </keep-alive>
    </div>
    <div class="subscribe" v-if="!hasAuth" v-show="tabView != 'Discussion'">
      <button @click="buyCourse" v-if="showPurchase">订购课程</button>
      <button class="temp" v-else>敬请期待</button>
    </div>
    <div class="send-message" v-show="tabView == 'Discussion'">
      <input type="text" v-model="messageInput" :disabled="!isLogin" @blur="handleBlur" />
      <button
        @click="send"
        :disabled="messageInput.trim().length==0 && isLogin"
      >{{isLogin ? "发送" : '登陆'}}</button>
    </div>
    <div
      v-show="payShow"
      style="position:fixed;top:0;width:100%;height:100%;background-color:#000;opacity:0.7;z-index:1000"
    ></div>
    <div
      v-show="payShow"
      style="width:5rem;height:3rem;margin:auto;background-color:#fff;position:absolute;top:0;left:0;opacity:1;right:0;bottom:0;z-index:1001;border-radius:10px;"
    >
      <p style="font-size:0.38rem;color:#474747;text-align:center;margin:0.8rem 0 0.72rem;">是否已支付完成</p>
      <div style="border-top:1px solid #ddd;padding:0 0.2rem;">
        <p
          @click="paycancel"
          style="float:left;background-color:#fff;width:2.2rem;height:0.9rem;line-height:0.9rem;font-size:0.28rem;"
        >取消</p>
        <p
          @click="payok"
          style="float:left;background-color:#fff;width:2.3rem;height:0.9rem;line-height:0.9rem;font-size:0.28rem;border-left:1px solid #ddd;"
        >确认</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Detail from "./tabView/detail";
import Category from "./tabView/category";
import Discussion from "./tabView/discussion";
import Description from "./tabView/description";
import { getCookie } from "@/utils/cookie";
import {
  playLiveCourse,
  getLiveCourseDetail,
  refreshTime,
  getCourseList,
  getStartTime
} from "@/utils/http";
import { throttle } from "@/utils/util";
import { mapMutations, mapState } from "vuex";
import config from "@/utils/config";
// import emH5Share from "../emH5Share.js";
const navMap = {
  normalCourceLive: [
    { label: "详情", view: "Detail" },
    { label: "目录", view: "Category" },
    { label: "讨论", view: "Discussion" }
  ],
  normalCourseReview: [
    { label: "详情", view: "Detail" },
    { label: "目录", view: "Category" }
  ],
  dailyFreeLive: [{ label: "讨论", view: "Discussion" }],
  dailyFreeReview: [
    { label: "简介", view: "Description" },
    { label: "更多", view: "Category" }
  ]
};
export default {
  data() {
    return {
      currentIndex: 0,
      discussionArray: [],
      messageInput: "",
      tabView: "Detail",
      isWeixin: /(MicroMessenger)/i.test(navigator.userAgent),
      hasAuth: true,
      courseTitle: "",
      priceInfo: {
        price: 0,
        originalPrice: 0
      },
      purchaseNum: 0,
      videoImg: null,
      videoTitle: "",
      viewNum: 0,
      publishTime: "",
      myMessageIndexArray: [],
      showLastSeen: false, //是否显示播放进度提示
      playTime: 0, //播放进度
      payShow: false,
      authType: 1, //课程类型，2系列课 1按节数
      currentChannel: "",
      isLogin: true,
      isPreview: false, //预告
      previewStartTime: "",
      onlineNum: 0,
      showPurchase: true,
      previewImg: null, //预告封面
      miniToken: ""
    };
  },
  components: {
    Detail,
    Category,
    Discussion,
    Description
  },
  watch: {
    $route: {
      //监听路由变化，”目录“或者”更多“标签页点击视频切换时触发
      handler: function(route) {
        const query = route.query;
        // 切换回放时离开频道再次进入直播时im会将网络资源占光!所以切换时不离开频道
        // if (status == 2) {
        // this._clientSDK && (this._clientSDK.exitChannel()); //切换视频到回放时，离开im频道
        // }
        if (query.status == 1 && this.dailyFree) {
          //早盘点评类课程切换到直播时，切换tabview为讨论界面
          this.tabView = "Discussion";
        }
        this.currentChannel = query.channelId;
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(["ct", "ut"]),
    contentHeight() {
      //视频下方内容高度，有权限不显示订阅按钮
      let height = "6.02rem";
      if (this.hasAuth && this.tabView != "Discussion") {
        height = "5.02rem";
      }
      return {
        height: `calc(100vh - ${height})`
      };
    },
    dailyFree() {
      return this.$route.query.type == -1 || this.$route.query.type == -3; //早盘点评类课程
    },
    nav() {
      const status = +this.$route.query.status;
      let key = "normalCourceLive";
      switch (status) {
        case 0:
        case 2:
          if (this.dailyFree) {
            key = "dailyFreeReview";
          } else {
            key = "normalCourseReview";
          }
          break;
        case 1:
          if (this.dailyFree) {
            key = "dailyFreeLive";
          }
        default:
          break;
      }
      if (!this.hasAuth) {
        key = "normalCourseReview";
      }
      return navMap[key];
    }
  },
  filters: {
    formatTime(time) {
      let min = Math.floor(time / 60);
      let seconds = parseInt(time % 60);
      let formatSec = seconds <= 9 ? `0${seconds}` : seconds;
      return `${min}分${formatSec}秒`;
    }
  },
  beforeDestroy() {
    this._clientSDK && this._clientSDK.exitChannel(this.$route.query.channelId);
    this.videoPlayer && this.videoPlayer.dispose();
  },
  mounted() {
    window.AG.emH5ShareNeed(0);
    const query = this.$route.query;
    window.onNetChange = json => {
      if (JSON.parse(json).type != "Wifi") {
        this.$alert("正在使用流量播放");
      }
    };
    const json = '{"callbackname":"onNetChange"}';
    if (window.AG.InApp) {
      this.showPurchase = false;
      if (navigator.userAgent.indexOf("Android") > -1) {
        prompt("emGetNetStatus", json);
      } else {
        eastmoney.emGetNetStatus(json);
      }
    }
    if ((query.status == 2 || query.status == 0) && this.dailyFree) {
      this.tabView = "Description";
    }
    if (query.status == 1 && this.dailyFree) {
      this.tabView = "Discussion";
    }
    //初始化浪客播放器
    this.initVideoPlayer();
    this.checkLogin().then(isLogin => {
      if (!isLogin) {
        this.isLogin = false;
        if (query.free == 1) {
          // if (query.channelId) {
          //     // this.playFirstVideo(query);
          //     this.getCourseDetail();
          // } else { //未登录只能从预告进入
          //     // this.isPreview = true;
          //     // this.getPreviewPlayTime(query.noticeId);
          //     // if (!this.dailyFree) {
          this.getCourseDetail();
          // }
          // }
          this.hasAuth = true;
        } else {
          this.goLogin();
        }
      } else {
        this.isLogin = true;
        //已登录获取用户信息
        if (window.AG.InApp) {
          //app环境调用客户端方法获取ct,ut
          AG.getUserLoginInfo(json => {
            if (json.code == 0) {
              this.setToken(json.data);
              this.getCourseDetail();
            }
          });
        } else {
          //非app环境读取cookie的ct,ut
          const ct = getCookie("ct");
          const ut = getCookie("ut");
          this.setToken({
            ct,
            ut
          });
          this.getCourseDetail();
        }
      }
    });
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  methods: {
    ...mapMutations(["setToken"]),
    initVideoPlayer() {
      emav.addLanguage("zh-CN", {
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "当前直播已结束！"
      });
      this.videoPlayer = emav("player", {
        autoplay: true,
        controls: true,
        width: window.innerWidth,
        posterImage: true,
        bigPlayButton: true,
        poster: "",
        controlBar: {
          children: [
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "progressControl",
            "fullscreenToggle"
          ],
          // playToggle: true,
          // volumePanel: true,
          remainingTimeDisplay: false,
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          progressControl: true,
          playbackRateMenuButton: true,
          fullscreenToggle: true
        },
        theme: {
          name: "mobile",
          playProgressColor: "#e95700",
          loadProgressColor: "#fff",
          controlBar: [
            "currentTimeDisplay",
            "progressControl",
            "durationDisplay",
            "fullscreenToggle"
          ]
        },
        bigPlayButton: true,
        showBigPlayButtonOnPaused: true,
        pausedView: {
          title: "",
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          fontSize: 1.8,
          fullscreenFontSize: 3.8
        },
        progressTracker: {
          backgroundColor: "#e95700",
          height: 0.2
        },
        fastXWard: {
          color: "#e95700"
        },
        statistic: {
          activeTime: true
        }
      });
      if (this.$route.query.status == 2) {
        this.videoPlayer.on(
          "timeupdate",
          throttle(() => {
            this.updatePlayTime();
          }, 30000)
        );
        this.videoPlayer.on("ended", () => {
          this.updatePlayTime();
        });
      }
    },
    showAlert() {
      if (window.AG.InApp) {
        window.AG.getModuleInfo("deviceInfo", json => {
          if (+json.code === 0) {
            if (json.data.deviceInfo.network !== "WIFI") {
              this.$alert("正在使用流量播放");
            }
          }
        });
      }
    },
    getPreviewPlayTime(noticeId) {
      getStartTime({
        ctoken: this.ct,
        utoken: this.ut,
        noticeId
      }).then(res => {
        this.previewStartTime = res.data.data.startTime.slice(0, 16);
        this.videoTitle = res.data.data.videoName;
        this.previewImg = res.data.data.image;
      });
    },
    initShare() {
      // emH5.ShareData = {
      //   title: this.videoTitle || this.courseTitle || "金牌课程",
      //   desc: "为您精选投资课程",
      //   link: window.location.href,
      //   // imgUrl:
      //   //   "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
      //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
      //   fail: function(res) {
      //     alert(JSON.stringify(res));
      //   }
      // };
      // emH5.Share();
    },
    updatePlayTime() {
      refreshTime({
        channelId: this.$route.query.channelId,
        courseId: this.$route.query.courseId,
        playtime: this.videoPlayer.currentTime(),
        ctoken: this.ct,
        utoken: this.ut
      }).then(res => {
        this.playTime = this.videoPlayer.currentTime();
      });
    },
    playFirstVideo(query) {
      //播放课程的第一条视频，从我的课程入口进入
      getCourseList({
        courseId: query.courseId,
        pageNum: 1,
        pageSize: 1,
        ctoken: this.ct,
        utoken: this.ut
      }).then(res => {
        const data = res.data.data;
        let firstVideo = data[0];
        this.changeVideo({
          channelId: firstVideo.channelId,
          courseId: firstVideo.courseId,
          status: firstVideo.videoStatus,
          bought: firstVideo.bought,
          free: firstVideo.free
        });
      });
    },
    changeVideo(query) {
      this.videoPlayer.pause();
      if (!query.bought) {
        this.buyCourse();
        return;
      }
      const { channelId, courseId, status, free, noticeId } = query;
      this.$router.replace({
        path: "/livecourse",
        query: {
          courseId,
          channelId,
          status,
          free,
          noticeId,
          type: this.$route.query.type
        }
      });
      if (status != 0) {
        this.isPreview = false;
        this.initVideo(query.status);
      } else {
        this.hideLastSeen();
        this.isPreview = true;
        this.getPreviewPlayTime(channelId);
      }
    },
    goLogin() {
      //跳转登录页
      if (window.AG.InApp) {
        //app环境调用客户端登陆
        window.AG.eventLogin(json => {
          if (json.code == 0) {
            // 登陆成功刷新页面
            location.reload();
          } else {
            // 登陆失败（包括用户手动返回退出登陆页面），返回上一级页面
            this.$router.go(-1);
          }
        });
      } else {
        //非app环境，跳转h5登陆页面
        location.href = `https://mpassport.eastmoney.com/login?backUrl=${encodeURIComponent(
          location.href
        )}`;
      }
    },
    changeNav(index, view) {
      this.currentIndex = index;
      this.tabView = view;
    },
    //初始化视频信息，获取视频播放地址和视频图片
    initVideo(status) {
      let channelId = (this._channelId = this.$route.query.channelId);
      let courseId = this.$route.query.courseId;
      // this.playTime = 0;
      clearTimeout(this.timer);
      playLiveCourse({
        ctoken: this.ct,
        utoken: this.ut,
        playWhich: "0", //播放当前视频
        playType: status, //直播还是回放
        channelId,
        courseId
      }).then(json => {
        const res = json.data;
        if (res.code == 0) {
          let data = res.data;
          this.videoTitle = data.videoTitle.replace(/#/g, "");
          this.videoPlayer.pausedView.titleEl_.innerHTML = data.videoTitle.replace(
            /#/g,
            ""
          );
          this.viewNum = data.viewerCount;
          this.userId = data.userId;
          this.publishTime = data.startTime;
          //解决直播时分享出去时状态与课程实际状态不一致
          //分享时为直播状态，从分享的链接进入时直播可能结束，刷新页面状态
          if (data.videoStatus != status) {
            this.$router.replace({
              path: "/livecourse",
              query: {
                ...this.$route.query,
                status: data.videoStatus
              }
            });
            window.location.reload();
          }
          if (status == 1) {
            this.videoPlayer.src(channelId);
            this.onlineNum = data.viewerCount;
            this.initIMSdk(data.imUserId, data.token, channelId);
            this.hideLastSeen();
          } else {
            this.videoPlayer.src(data.videoUrl);
            const playTime = data.playtime || 0;
            this.playTime = playTime;
            if (playTime > 0) {
              this.showLastSeen = true;
              this.timer = setTimeout(() => {
                this.hideLastSeen();
              }, 30000);
            } else {
              this.hideLastSeen();
            }
          }
          this.videoPlayer.poster(data.recordImgUrl);
          this.showAlert();
          // this.initShare();
        }
      });
    },
    //初始化imSDK
    initIMSdk(imUserID, accessToken, channel) {
      const configs = {
        uid: "", // 不用管
        debug: process.env.NODE_ENV === "development", // true,开启debug,显示log;false,不显示log
        isPoll: true, // true,通讯走polling;false，通讯走websocket;
        comment: false, // 不用管
        websocketUrl: "ws://lvbim.eastmoney.com:20009",
        baseUrl: "http://lvbim.eastmoney.com:2016"
      };
      this._clientSDK = new IMClientSDK({
        isPoll: configs.isPoll,
        debug: configs.debug,
        ip: configs.websocketUrl,
        baseUrl: configs.baseUrl
      });
      var imUserID = imUserID; // 登录用户的id
      var accessToken = accessToken; // 接口请求需要用到的token信息；
      var channel = channel; // 测试用的固定的频道
      this._clientSDK.log = function(msg, msg1, msg2, msg3, msg4) {
        console.log(msg);
      };
      //初始化成功了再start
      //配置加载完了
      const _this = this;
      this._clientSDK.on("initSuccess", function() {
        _this._clientSDK.start();
      });
      //websocket链接成功
      this._clientSDK.on("connected", function() {
        _this._clientSDK.info("开始登录");
        _this._clientSDK.loginByIMToken(imUserID, accessToken, "websocket", 1);
        _this._clientSDK.log("channelID:" + channel);
        _this._clientSDK.joinChannel(
          channel,
          function(data) {
            _this._clientSDK.log("joinchannel success");
          },
          function(res) {
            _this._clientSDK.log("joinchannel fail");
          }
        );
      });
      this._clientSDK.on("messages", function(data, protocol) {
        console.log(protocol, _this._clientSDK.protoHooks[protocol], data);
        _this._clientSDK.log(
          protocol,
          _this._clientSDK.protoHooks[protocol],
          data
        );
        // 113 在线人数
        // 107 点亮
        // 111 Top50通知
        // 100 普通消息
        // {0: "心跳", 1: "通道重置", 2: "登录", 10: "退出登录", 31: "订阅频道", 32: "取消订阅频道",
        // 33: "频道被关闭", 100: "普通消息", 101: "弹幕消息", 102: "频道通知", 103: "个人通知",
        // 104: "礼品全局消息", 105: "礼品频道消息", 106: "全局默认通知", 107: "点亮", 108: "关注通知",
        // 109: "禁言通知", 110: "进入房间通知", 111: "Top50通知", 112: "个人信息变动", 113: "在线人数",
        // 114: "私信", 115: "设置管理员通知", 116: "主播断开", 117: "异地登陆", 118: "主播回到频道",
        // 119: "红包", 120: "连麦", 140: "收到私信", 160: "发送私信", 161: "发送私信反馈",
        // 162: "发送私信回执", 163: "发送私信回执反馈", 164: "发送到组群", 165: "发送到组群反馈",
        // 166: "发送到频道", 167: "发送到频道反馈", 168: "发送组群消息回执", 169: "发送群组消息回执的反馈",
        // 171: "收到私信回执", 172: "收到组群消息", 173: "收到组群消息回执", 174: "收到频道消息",
        // 253: "登录反馈", 254: "收到session info", 255: "心跳反馈"}
        switch (protocol) {
          //接受频道消息
          case _this._clientSDK.protoCodes.joinChannel: //31
          case _this._clientSDK.protoCodes.exitChannel: //32
            break;
          case _this._clientSDK.protoCodes.channelClosed: //33
            if (data == _this.$route.query.channelId) {
              setTimeout(() => {
                _this.$toast({
                  message: "当前直播已结束",
                  ok: () => {
                    _this.$router.push("/");
                  }
                });
              }, 15000);
            }
            break;
          case _this._clientSDK.protoCodes.receivePrivateMessage: //140
            //$(".history").append("收到：" + JSON.stringify(data) + "<br>");
            break;
          case _this._clientSDK.protoCodes.channelMessageList: //100
            var json = data.MessageList[0];
            var msg = JSON.parse(json.Content);

            switch (msg.type) {
              case 0: //普通消息
                // const index = _this.msgIdArray.indexOf(json.MsgID);
                // console.log("json.Sender", json.Sender);
                const isMessageFromLocal = false;
                if (_this.userId == json.Sender.IntegratedSysUserID) {
                  for (let i = 0; i < _this.myMessageIndexArray.length; i++) {
                    const key = _this.myMessageIndexArray[i];
                    if (_this.discussionArray[key].msgId === json.MsgID) {
                      _this.discussionArray[key].level = json.Sender.Level;
                      isMessageFromLocal = true;
                      break;
                    }
                  }
                  if (!isMessageFromLocal) {
                    _this.discussionArray.push({
                      content: msg.content,
                      sender: json.Sender.Nickname,
                      level: json.Sender.Level,
                      msgId: json.MsgID,
                      senderId: json.Sender.IntegratedSysUserID
                    });
                  }
                } else {
                  _this.discussionArray.push({
                    content: msg.content,
                    sender: json.Sender.Nickname,
                    level: json.Sender.Level,
                    msgId: json.MsgID,
                    senderId: json.Sender.IntegratedSysUserID
                  });
                  // _this.msgIdArray.push(json.MsgID);
                }
                break;
              case 1:
              case 2:
                _this.discussionArray.push({
                  content: msg.content,
                  sender: json.Sender.Nickname,
                  level: json.Sender.Level,
                  id: json.MsgID
                });
                break;
              case 3:
              case 6:
                break;
              case 17:
                break;
              default:
                break;
            }
            _this._clientSDK.log(msg);
            break;
          case _this._clientSDK.protoCodes.sessionInfo: //254
          case _this._clientSDK.protoCodes.sendPrivateMessageFeedback: //161
          case _this._clientSDK.protoCodes.sendGroupReceiptFeedback: //169
            break;
          case _this._clientSDK.protoCodes.onlineNumMessage: //113 在线人数
            _this.onlineNum = data.Num;
            break;
          case _this._clientSDK.protoCodes.lightMessage: //107 点亮
            break;
          default:
        }
      });
    },
    //发送聊天消息
    send() {
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      const _this = this;
      const content = this.messageInput;
      const uid = Math.random();

      this.discussionArray.push({
        content,
        level: " ",
        sender: "我",
        senderId: _this.userId,
        uid
      });

      this.myMessageIndexArray.push(this.discussionArray.length - 1);
      this.messageInput = "";
      this._lastSend = this.discussionArray.length - 1;
      this._clientSDK.sendToChannel(
        +this._channelId, //用websocket通讯时，chaneelId必须为Number类型
        JSON.stringify({
          content,
          type: 0
        }),
        200,
        function(res) {
          for (let i = 0; i < _this.myMessageIndexArray.length; i++) {
            const key = _this.myMessageIndexArray[i];
            if (_this.discussionArray[key].uid === uid) {
              _this.discussionArray[key].msgId = res.data;
              break;
            }
          }
        },
        function() {}
      );
    },
    //获取课程详情
    getCourseDetail() {
      const courseId = this.$route.query.courseId;
      getLiveCourseDetail({
        ctoken: this.ct,
        utoken: this.ut,
        courseId
      }).then(json => {
        const res = json.data;
        if (res.code == 0) {
          const data = res.data;
          this.courseTitle = data.name;
          this.priceInfo.price = data.price || 0;
          this.priceInfo.originalPrice = data.originalPrice || 0;
          this.priceInfo.minPrice = data.monthPrice || 0;
          this.priceInfo.minOriginalPrice = data.monthOriginalPrice || 0;
          this.purchaseNum = data.purchaseQuantity;
          // this.videoImg = data.imageUrl;
          this.videoImg = data.recordImgUrl;
          this.authType = data.authType;
          if (data.free || data.bought) {
            //免费直播或者已购买
            this.hasAuth = true;
            if (this.$route.query.status && this.$route.query.status != 0) {
              this.initVideo(this.$route.query.status);
            } else {
              // this.playFirstVideo(this.$route.query)
              if (this.$route.query.status == 0) {
                this.isPreview = true;
                this.getPreviewPlayTime(
                  this.$route.query.noticeId || this.$route.query.channelId
                );
              } else {
                this.playFirstVideo(this.$route.query);
              }
            }
          } else {
            this.hasAuth = false;
            // this.nav.splice(2, 1);
          }
        }
      });
    },
    //跳转上次播放位置
    jumpToTime() {
      this.videoPlayer.currentTime(this.playTime);
      this.videoPlayer.play();
      this.showLastSeen = false;
    },
    //隐藏记忆播放
    hideLastSeen() {
      this.showLastSeen = false;
      this.playTime = 0;
    },
    buyCourse() {
      if (window.AG.InApp) {
        return;
      }
      var url =
        config.buyApi +
        "?productId=" +
        this.$route.query.courseId +
        "&paySuccessUrl=" +
        "&backUrl=" +
        "&miniToken=" +
        this.miniToken;
      if (window.AG.InApp) {
        if (window.AG.ISIOS) {
          location.href = `eastmoney://wireless/txtrade/h5?requestTradeLogin=0&url=${url}`;
          this.jumpTimer = setInterval(() => {
            var that = this;
            window.AG.checkUserIsLogin(function(result) {
              if (result) {
                that.isLogin = 1;
                window.AG.getUserLoginSuccessData(function(json) {
                  that.ctoken = json.ct;
                  that.utoken = json.ut;
                  that.nickName = json.nickname;
                  // that.getParams();
                  window.location.reload();
                });
              } else {
                that.ctoken = "";
                that.utoken = "";
                that.getParams();
                window.location.reload();
                that.isLogin = 0;
              }
            });
          }, 2000);
        } else {
          location.href = `dfcft://webpayh5?url=${encodeURIComponent(url)}`;
          this.jumpTimer = setInterval(() => {
            var that = this;
            window.AG.checkUserIsLogin(function(result) {
              if (result) {
                that.isLogin = 1;
                window.AG.getUserLoginSuccessData(function(json) {
                  that.ctoken = json.ct;
                  that.utoken = json.ut;
                  that.nickName = json.nickname;
                  // that.getParams();
                  // window.location.reload();
                });
              } else {
                that.ctoken = "";
                that.utoken = "";
                // that.getParams();
                window.location.reload();
                that.isLogin = 0;
              }
            });
          }, 2000);
          this.payShow = true;
        }
      } else {
        url =
          config.buyApi +
          "?productId=" +
          this.$route.query.courseId +
          "&paySuccessUrl=" +
          "&backUrl=" +
          encodeURIComponent(location.href) +
          "&miniToken=" +
          this.miniToken;
        location.href = url;
        // console.log(url)
      }
    },
    paycancel() {
      this.payShow = false;
      window.location.reload();
    },
    payok() {
      this.payShow = false;
      window.location.reload();
    },
    checkLogin() {
      return new Promise(resolve => {
        if (window.AG.InApp) {
          window.AG.checkUserIsLogin(function(result) {
            resolve(result);
          });
        } else {
          if (!getCookie("ct") && !getCookie("ut")) {
            resolve(false);
          } else {
            resolve(true);
          }
        }
      });
    },
    handleBlur() {
      if (this.isWeixin) {
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>

<style scoped>
.video-wrapper {
  height: 4.25rem;
  min-height: 4.25rem;
  box-sizing: border-box;
  position: relative;
}
.video-img {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}

.mask {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
}
.preview-mask {
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
}
.tips {
  margin-bottom: 0.4rem;
  font-size: 0.45rem;
  font-weight: 600;
}
.mask button {
  width: 2.76rem;
  line-height: 0.6rem;
  background: #ff6600;
  border-radius: 4px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 0.3rem;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.last-seen {
  position: absolute;
  top: 2.95rem;
  left: 4px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  line-height: 0.6rem;
  border-radius: 4px;
}
.close {
  padding: 0 8px;
}
.jump {
  padding: 0 8px;
  color: #f00;
}
.nav {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}
.nav li {
  box-sizing: border-box;
  width: 1.6rem;
  height: 0.75rem;
  line-height: 0.75rem;
  color: #666666;
  font-size: 0.3rem;
}
.nav .active {
  color: #f6621c;
  border-bottom: 2px solid #f6621c;
}
.content-wrapper {
  height: calc(100vh - 6.02rem);
  overflow: auto;
  font-size: 16px;
}
.subscribe,
.send-message {
  height: 1rem;
  line-height: 1rem;
  font-size: 16px;
}
.subscribe button {
  width: 5.8rem;
  line-height: 0.8rem;
  background: #f6621c;
  outline: none;
  color: #fff;
  border: none;
  border-radius: 0.4rem;
  font-size: 0.35rem;
  font-weight: 600;
}
.subscribe .temp {
  background: #999999;
}
.send-message {
  display: flex;
  background: #f5f5f5;
  align-items: center;
  padding: 0 8px;
}
.send-message button {
  margin-left: 16px;
  background: transparent;
  border: none;
  outline: none;
  color: #f6621c;
  font-size: 16px;
}
.send-message button:disabled {
  opacity: 0.5;
}
.send-message input {
  width: 5.8rem;
  height: 0.6rem;
  padding: 0 8px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
  font-size: 16px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
/* .slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
} */
.slide-fade-enter
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100vw);
}
.discussion {
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  overflow: auto;
  text-align: left;
  background: #f5f5f5;
}
.video-wrapper /deep/ .emav {
  height: 100%;
}
</style>
